module.exports = __webpack_public_path__ + "static/media/bg6.25fd8408.jpg";